import React, { Fragment } from 'react';

import numeral from 'numeral';
import moment from 'moment';

import {
  Box,
  makeStyles,
  Tooltip,
  colors,
  Avatar,
  IconButton,
  Icon,
  Grid,
  Card,
  CardContent,
  Typography,
  Divider,
  Link,
  Radio,
  FormControlLabel
} from '@material-ui/core';

import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import BuildIcon from '@material-ui/icons/Build';

const useStyles = makeStyles((theme) => ({
  root: {
  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200]
  }
}));

const formatDecimal = (value) => {
  return numeral(value).format('0.00').replace('.', ',');
}

const formatNumber = (value, mask) => {
  return numeral(value).format(mask);
}

const formatDate = (value) => {
  if (value) {
    return moment(value).format('DD/MM/YYYY')
  } else {
    return ""
  }
}

const truncateValue = (value, size) => {
  if (value.length > size) {
    return value.substring(size - 3, 0) + '...';
  } else {
    if (value == '') {
      return 'Não Definido'
    } else {
      return value;
    }
  }
}

const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const Record = ({ icon, item, vision, resultMode, openEdition, openDeletion, openTreatment, openExportDialog, selected, handleSelect, selectExpense, values, stock }) => {

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    if (event.currentTarget.id == 'excel' || event.currentTarget.id == 'csv' || event.currentTarget.id == 'pdf') {
      openExportDialog(event.currentTarget.id);
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = (event) => {
    setAnchorEl(null);
  };


  const getFieldValue = (column) => {
    try {
      var value = eval(column.field);
      return ((value) ? value : "");
    } catch (error) {
      return "";
    }
  }

  return (
    <Fragment>

      <Grid
        item
        lg={3}
        md={6}
        xs={12}
      >
        <Card className={classes.root}>

          <CardContent>
            <Box
              display="flex"
              justifyContent="center"
              mb={1}
            >
              <Avatar
                className={classes.avatar}
              >
                {<Icon component={icon} style={{ color: colors.cyan[500] }} ></Icon>}
              </Avatar>
            </Box>

            <Typography
              align="center"
              color="textPrimary"
              gutterBottom
              variant="h4"
            >
              <Link
                onClick={() => { selectExpense(values, item, stock) }}
              >
                <b>{getFieldValue(resultMode.columns[0])}</b>
              </Link>
            </Typography>

            <Typography
              align="center"
              color="textPrimary"
              variant="body1"
            >
              <b>{getFieldValue(resultMode.columns[1])} - {getFieldValue(resultMode.columns[2])}</b>
            </Typography>


            {resultMode.columns.map((col, index) => (
              (index > 2) ? (
                <Typography
                  noWrap={(col.wrap)}
                  align="center"
                  color="secondary"
                  variant="h5"
                >
                  <b>{col.name}:</b> {getFieldValue(col)}
                </Typography>

              ) : (
                ""
              )
            ))}

          </CardContent>

          <Divider />

          <Box p={1}>
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              spacing={1}
            >
              <Grid item>
                <Grid container

                >
                  <Grid item
                    md={12}
                    xl={12}
                  >
                    <FormControlLabel
                      control={<Radio id={item.id}
                        value={item.id}
                        checked={(selected) ? selected.id === item.id : false}
                        onChange={handleSelect(item)} >
                      </Radio>}
                      label="Material Selecionado"
                    />
                  </Grid>

                  {(resultMode.config != LEVEL_ACCESS_HIDE) ? (
                    <Grid item
                      md={4}
                      xl={4}
                    >
                      <Tooltip title="Tratar">
                        <IconButton
                          color="secondary"
                          disabled={resultMode.config == LEVEL_ACCESS_DISABLED}
                          children={<BuildIcon />}
                          size="medium"
                          onClick={() => { openTreatment(item) }}></IconButton>
                      </Tooltip>
                    </Grid>
                  ) : ('')}

                  {(resultMode.update != LEVEL_ACCESS_HIDE) ? (
                    <Grid item
                      md={4}
                      xl={4}
                    >
                      <Tooltip title="Editar">
                        <IconButton
                          color="secondary"
                          disabled={resultMode.update == LEVEL_ACCESS_DISABLED}
                          children={<EditRoundedIcon />}
                          size="medium"
                          onClick={() => { openEdition(item) }}>
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  ) : ('')}

                  {(resultMode.delete != LEVEL_ACCESS_HIDE) ? (
                    <Grid item
                      md={4}
                      xl={4}
                    >
                      <Tooltip title={"Excluir"}>
                        <IconButton
                          color="secondary"
                          disabled={resultMode.delete == LEVEL_ACCESS_DISABLED}
                          children={<DeleteRoundedIcon />}
                          size="medium"
                          onClick={() => { openDeletion(item) }}></IconButton>
                      </Tooltip>
                    </Grid>
                  ) : ('')}

                </Grid>
              </Grid>

              <Grid
                item
              >
              </Grid>
            </Grid>
          </Box>
        </Card>

      </Grid>

    </Fragment>
  );
}

export default Record;